<template>
  <div class="admin_orders">
    <v-card>
      <v-toolbar flat color="white">
        <v-card-title>
          <v-btn color="indigo" dark class="mb-2" rounded small @click="back"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-title @click="checkItems">
          {{user.name}}'s Order 
        </v-card-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table :headers="headers" :items="orders"  :search="search" sort-by="name" class="elevation-1"><!--  -->
        <template v-slot:no-data>
          <v-list-item-title><b>Orders Are Empty</b></v-list-item-title>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import {fb,db} from '@/firebase';

  export default {
    name : "admin_orders",
    data: () => ({
      search: '',
      nav_title: 'Order Page',
      headers: [
        { text: 'Date', align: 'center', value: 'created_at' },
        { text: 'Address', align: 'center', value: 'address'},
        { text: 'Client', align: 'center', value: 'client'},
        { text: 'Delivery Method', align: 'center', value: 'delivery'},
        { text: 'Payment Method', align: 'center', value: 'payment'},
        { text: 'SubTotal', align: 'center', value: 'total'},
        { text: 'Order Status', align: 'center', value: 'total'}
      ],
      orders: [],
      user: null,
      matchitems:[]
    }),

    created(){
      //fetch data from the firestore
      db.collection('orders').where('user','==',fb.auth().currentUser.uid).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let order = doc.data()
          order.id =  doc.id
          this.orders.push(order) 
        })
      })
      db.collection('user').where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data(),
          this.user.id = doc.id//
        })
      })
    },
    
    firestore() {
      return {
        carti: db.collection('orders')
      }
    },

    methods: {
      priceSum(){
          return this.orders.reduce((prev,cur) => prev + cur.product_total,0)
      },
      quantitySum(){
          return this.orders.reduce((prev,cur) => prev + cur.product_quantity,0)
      },
      checkItems(){
        for(var i=0; i<=this.orders.length; i++){
          if(this.order.user == this.user.alias){
            this.matchitems.push(this.order)
          }
        }
      },
      getImage(product_image){
        return product_image[0]
      },

      back(){
        this.$router.go(-1)
      },
      
      deleteClient(item) {
        /* eslint-disable */
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })/* eslint-enable */
        .then((result) => {
          if (result.value) {
            this.$firestore.carti.doc(item.id).delete()            
            /* eslint-disable */
            Toast.fire({
              type: 'success',
              title: 'Deleted successfully'
            })
            /* eslint-enable */
            this.orders = this.orders.filter(order =>{
            return order.id != item.id
          })
          }
        })
      }
    }
  }
</script>
